// QR Menüler sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.qrMenuPage';

export const qrMenuPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'QR menüler nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu sayfada müşterilerin telefonla okuttuğu QR menüleri ve online bilet sayfanızı yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni menü ve kısayollar'),
    table: t(`${G}.regions.table`, 'QR menüler / Online bilet sayfaları'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Sayfa iki bölümden oluşur: "QR Menüler" (masadan sipariş alınan menüler) ve "Online Bilet Sayfaları" (bilet satışı ve rezervasyon sayfası). Her satırda menünün adı ve bağlı olduğu şube görünür; şube seçilmemişse "Şube Atanmamış" yazar.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Yeni QR menü veya online bilet sayfası'),
      text: t(`${G}.s2.text`, '"Yeni QR Menü Ekle" düğmesiyle yeni bir menü oluşturun. Online bilet sayfası için düğmenin yanındaki ⋮ menüsünden "Online Bilet Sistemi Oluştur" seçilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'En fazla 1 online bilet sayfası oluşturabilirsiniz.'),
        t(`${G}.s2.tip2`, 'Şube yöneticisi girişinde yeni menü ekleme, silme, Müşteriler ve Site Adresi seçenekleri görünmez.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Mutfak, siparişler ve site adresi'),
      text: t(`${G}.s3.text`, '⋮ menüsünden (mobilde üstteki düğmelerden) "Mutfak Ekranı", "Masa Siparişleri", "Müşteriler" ve "Site Adresi Ayarla" ekranlarına geçebilirsiniz. Site adresi tanımlarsanız menü bağlantıları ve QR kodlar kendi alan adınızı kullanır.'),
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Menüyü görüntüleyin ve düzenleyin'),
      text: t(`${G}.s4.text`, '"Görüntüle" menüyü müşterinin göreceği haliyle yeni sekmede açar. Satırdaki ⋮ düğmesinden: "Düzenle" (ad ve şube), "Ayarlar" (ürünler, şablon, personel, yazdırma, mutfak ekranı) seçilir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Masalar ve QR kod'),
      text: t(`${G}.s5.text`, 'QR menülerde ⋮ menüsünde ayrıca "Masa Ekle", "Masalar" ve "4K QR İndir" bulunur. "4K QR İndir" menünün genel bağlantısını yüksek çözünürlüklü (3840 piksel) PNG olarak indirir; masaya özel QR kodlar "Masalar" ekranından indirilir.'),
      tips: [
        t(`${G}.s5.tip1`, 'Online bilet sayfalarında masa ve QR indirme seçenekleri yoktur.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Menüyü silme'),
      text: t(`${G}.s6.text`, '⋮ menüsündeki "Sil" onay penceresi açar. Silinen menü listeden kalkar; bu işlem geri alınamaz. Silmeden önce menünün masalarda kullanılmadığından emin olun.'),
    },
  ],
});
